<template>
  <div
    class="alert alert-warning flex items-center justify-center gap-2 md:gap-4 px-4 text-left text-xs font-medium md:mt-4 mx-1 md:mx-4 w-auto"
  >
    <NuxtIcon
      class="text-2xl"
      name="exclamation"
    />
    {{ $t('deposit.general.cpf_warning') }}
  </div>
</template>
